/**
*========================================
*	
*	Sizing / Spacing Script
*	
*========================================
*/

(function($) {

    $(document).on('ready', () => {

        /**
        *========================================
        *	
        *	Tiles
        *
        *========================================
        */
        
        $('.sci-tile.closed').each( function() {
            let that = $(this);
            let body = that.find('.sci-tile__body')
            let height = body[0].scrollHeight;

            that.on('mouseenter', function() {
                that.removeClass('closed');
                that.addClass('open');
                body.css('max-height', height);
            });

            // that.on('focus', function() {
            //     that.removeClass('closed');
            //     that.addClass('open');
            //     body.css('max-height', height);
            // });

            that.on('mouseleave', function() {
                that.removeClass('open');
                that.addClass('closed');
                body.css('max-height', 0);
            });
        })

        /**
        *========================================
        *	
        *	Filters
        *	
        *========================================
        */

        let isFiltering = false;
        let filteringTerm = '';
        let filterTerms = [];
        let filteredItemsCount = 0;
        
        $('.sci-filter-item').on('click', function () {
            checkFilterItems($(this));
        })

        function checkFilterItems(filterItem = null) {

            // const filterType = filterItem.data('type');

            const clearFilters = filterItem === null;

            let filterTerm = !clearFilters ? filterItem.data('term') : '';
            const colors = window.salemoche.venues[filterTerm]?.colors || window.salemoche.baseColors;

            if (filterTerms.indexOf(filterTerm) == -1) {

                if (filterTerm != '') {
                    const filterContainer = filterItem.closest('.sci-filter-container');
                    const isSingle = filterContainer.hasClass('sci-filters-single');
                    
                    // Exclusive Single Term behavior

                    if (isSingle) {
                        filterContainer.find('.sci-filter-item').each(function() {
                            let bufferFilterTerm = $(this).data('term');
                            filterTerms = filterTerms.filter(item => item != bufferFilterTerm)
                        });
                    }

                    filterTerms.push(filterTerm);
                }
                
            } else {
                filterTerms = filterTerms.filter(item => item != filterTerm)
            }

            $('.sci-filter-item').each( function () {
                let that = $(this);
                that.removeClass('active');
                let thatFilterTerm = that.data('term');
                const thatColors = window.salemoche.venues[thatFilterTerm]?.colors || window.salemoche.baseColors;

                that.css('background', thatColors.light);
                that.css('color', thatColors.dark);

                const filtersOverlap = compareArrays(getFilterableTerms(that), filterTerms);

                if (filtersOverlap.intersects) {
                    that.addClass('active');
                    that.css('background', thatColors.dark);
                    that.css('color', 'white');
                } else {
                    that.removeClass('active');
                    that.css('background', thatColors.light);
                    that.css('color', thatColors.dark);
                }
            })


            filterTiles();
        }

        function filterTiles() {
            const tiles = $('.sci-overview .sci-tile');
            let filteredItems = 0;
            const alert = $('.sci-filter-alert');
            const alertHeight = $('.sci-filter-alert')[0].scrollHeight + 32;

            tiles.removeClass(['filtered-in', 'open', 'force-open']);
            tiles.addClass(['closed']);
            tiles.addClass(['filtered-out']);
            alert.removeClass('active');
            alert.css('max-height', '0');

            tiles.each(function () {
                const tile = $(this);
                // const theme = tile.data('theme');
                // const date = tile.data('date');
                // const venue = tile.data('venue');

                // if ( term == theme || term == date || term == venue ) {
                //     tile.addClass(['filtered-in', 'open', 'force-open']);
                //     tile.removeClass('filtered-out');
                //     filteredItems ++;
                // }

                const filtersOverlap = compareArrays(getFilterableTerms(tile), filterTerms);
                // console.log(filterTerms, filtersOverlap.intersections.length, filterTerms.length, filtersOverlap.intersections );

                if (filtersOverlap.intersects && filtersOverlap.intersections.length === filterTerms.length ) {
                    tile.addClass(['filtered-in', 'open', 'force-open']);
                    tile.removeClass('filtered-out');
                    filteredItems ++;
                } else {
                }
            })


            // console.log(filteredItems, filterTerms, tiles.length);
            // filter alert

            if ( filteredItems === 0 ) {
                // $('.sci-overview .sci-tile').removeClass(['filtered-out', 'open', 'force-open']);
                // $('.sci-overview .sci-tile').addClass(['closed']);
                // $('.sci-overview .sci-tile:not(:nth-of-type(1)):not(:nth-of-type(2)):not(:nth-of-type(3))').removeClass(['filtered-out', 'open', 'force-open']);
                // $('.sci-overview .sci-tile:not(:nth-of-type(1)):not(:nth-of-type(2)):not(:nth-of-type(3))').addClass(['closed']);
                $('.sci-overview .sci-tile:not(:nth-of-type(1)):not(:nth-of-type(2)):not(:nth-of-type(3))').removeClass(['filtered-out', 'open', 'force-open']);
                $('.sci-overview .sci-tile:not(:nth-of-type(1)):not(:nth-of-type(2)):not(:nth-of-type(3))').addClass(['closed']);
                $('.sci-overview .sci-tile:nth-of-type(1), .sci-overview .sci-tile:nth-of-type(2), .sci-overview .sci-tile:nth-of-type(3)').addClass(['open', 'force-open']);
                $('.sci-overview .sci-tile:nth-of-type(1), .sci-overview .sci-tile:nth-of-type(2), .sci-overview .sci-tile:nth-of-type(3)').removeClass(['closed', 'filtered-out']);
                
                if ( filterTerms.length !== 0) {
                    alert.addClass('active');
                    alert.css('max-height', alertHeight);
                }

            }
        }

        $('.sci-filter-clear').on('click', function() {
            filterTerms = [];
            checkFilterItems();
            filterTiles();
        });

        function getFilterableTerms(element) {
            return [
                element.data('term'), 
                element.data('type'), 
                element.data('theme'), 
                element.data('date'), 
                element.data('venue'), 
                element.data('teens'),
                element.data('english'), 
                element.data('german'), 
            ].filter(item => item != undefined && item != "");
        }

        function compareArrays (array1, array2) {
            return {
                intersections: array1.filter(e => array2.indexOf(e) !== -1),
                intersects: array1.filter(e => array2.indexOf(e) !== -1).length > 0,
            };
        }

        /**
        *========================================
        *	
        *	Program
        *	
        *========================================
        */
        
        $('.sci-program-type').each( function () {
            let program = $(this);
            let handle = program.find('.sci-program-type__handle');
            let container = program.find('.sci-program-type__container');
            let height = container[0].scrollHeight;
            let open = false;

            container.css('max-height', 0);

            handle.on('click', function () {
                program.toggleClass('open');

                if (open) {
                    container.css('max-height', 0);
                } else {
                    container.css('max-height', height);
                }

                open = !open;
            })
        })

        /**
        *========================================
        *	
        *	Menu
        *	
        *========================================
        */
        
        $('.sm-burger').on('click', () => {
            $('header').toggleClass('active');
        })

        /**
        *========================================
        *	
        *	Scrolling
        *	
        *========================================
        */

        let scrollTop = $('html').scrollTop();

        setTimeout(() => {
            displayMenu(false);
        }, 100);

        $(window).on('scroll', () => {
            scrollTop = $('html').scrollTop();

            displayMenu(true);
        })

        $('.sci-scroll-button').on('click', function() {
            scrollTo('#sci-content');
        })

        function displayMenu (fromScrolling) {
            
            if ((window.salemoche.currentBreakpoint == 'small' || window.salemoche.currentBreakpoint == 'medium')) {

                $('header').removeClass('visible');

                if(fromScrolling) {
                    if (scrollTop >= 100) {
                        $('header').addClass('visible');
                    } else {
                        $('header').removeClass('visible');
                    }
                }
            }

        }

        function scrollTo(element) {
            let displacer = window.salemoche.currentBreakpoint == 'small' ? 68 : 144;
            let position = $(`${element}`).position().top;
            $("html").animate({ scrollTop: position - displacer }); 
        }

        /**
        *========================================
        *	
        *	Favorites
        *	
        *========================================
        */
        
        // $(document).on('favorites-updated-single', function(event, favorites, post_id, site_id, status){
        //     // Do stuff here as needed
        //     console.log(event, favorites, post_id, site_id, status);
        // });

        $('.sci-tile').each( function () {
            let that = $(this);
            const isFavorite = that.find('.simplefavorite-button.active').length > 0;

            if (isFavorite) {
                that.attr('data-favorized', true)
            }
        })

        // $('.sci-tile .sci-favorites-text').remove();

        $('.simplefavorite-button').each( function () {
            let that = $(this);
            const parentTile = that.parents('.sci-tile');
            const parentHeader = that.parents('.sci-detail-header');
            const buttonText = parentHeader.find('.sci-detail-header__content__favorite span');
            const title = parentTile.find('.sci-tile__heading__text__title').text() || parentHeader.find('h1').text();
            const favorizingModalText = window.salemoche.language.toLowerCase().includes('en') ? `${title} was added to your favorites` : `${title} wurde zu Ihren Favoriten hinzugefügt`;
            const favorizingText = window.salemoche.language.toLowerCase().includes('en') ? `add to favorites` : `zu Favoriten hinzufügen`;
            const unfavorizingModalText = window.salemoche.language.toLowerCase().includes('en') ? `${title} was removed from your favorites` : `${title} wurde von Ihren Favoriten entfernt`;
            const unfavorizingText = window.salemoche.language.toLowerCase().includes('en') ? `remove from your favorites` : `von Favoriten entfernen`;
            let isFavorite = that.hasClass('active');

            // console.log(parentHeader, buttonText, buttonText.text())

            if (isFavorite) {
                buttonText.text(unfavorizingText);
            } else {
                buttonText.text(favorizingText);
            }

            that.on('click', () => {
                isFavorite = that.hasClass('active');


                if (isFavorite) {
                    getModal(unfavorizingModalText);
                    parentTile.attr('data-favorized', false);
                    buttonText.text(unfavorizingText);
                } else {
                    getModal(favorizingModalText);
                    parentTile.attr('data-favorized', true);
                    buttonText.text(favorizingText);
                }

            })
        })

        function getModal(text) {
            $('.sci-modal').removeClass('active');
            let modal = $(`<div class="sci-modal">${text}</div>`);
            $('html').append(modal);

            setTimeout(() => {
                modal.addClass('active');
            }, 50);
            
            setTimeout(() => {
                modal.removeClass('active');
                // console.log('class removed');
            }, 2700);
            
            setTimeout(() => {
                modal.remove();
                // console.log('modal removed');
            }, 3000);
        }
        
    })

})(jQuery)